// App.js
import React from 'react';
import { ClerkProvider, SignedIn, SignedOut, SignIn } from '@clerk/clerk-react';
import { ChakraProvider } from '@chakra-ui/react';
import { SessionProvider } from './components/SessionContext'; // Import SessionProvider
import theme from './theme';
import Layout from './components/Layout';
import Walter from './components/Walter';


const clerkPublishableKey = process.env.REACT_APP_CLERK_FRONTEND_API;
console.log(process.env);
console.log(clerkPublishableKey);

function App() {
  return (
    <SessionProvider> {/* Wrap your app with SessionProvider */}
      <ClerkProvider publishableKey={clerkPublishableKey}>
        <ChakraProvider theme={theme}>
          <SignedOut>
            <SignIn />
          </SignedOut>
          <SignedIn>
            <Layout>
              <Walter />
            </Layout>
          </SignedIn>
        </ChakraProvider>
      </ClerkProvider>
    </SessionProvider>
  );
}

export default App;
